import { useMutation } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useHttpClient } from '../../../../utils/clients/rest-client';
import {
  GenericDeviceRequest,
  RecoveryGetDeviceStatusData,
  RecoveryUpdateFirmwareData,
} from '../../types/openapi/openapi-types';

export const useGetDeviceStatus = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors } = useErrors();

  return useMutation<AxiosResponse<RecoveryGetDeviceStatusData>, AxiosError<void>, GenericDeviceRequest>(
    ['recovery-getDeviceStatus'],
    async (body) => await httpClient.recovery.recoveryGetDeviceStatus(body),
    {
      onError: (error) => {
        handleRestErrors(error);
      },
    },
  );
};

export const useUpdateRecoveryFirmware = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors } = useErrors();

  return useMutation<AxiosResponse<RecoveryUpdateFirmwareData>, AxiosError<void>, GenericDeviceRequest>(
    ['recovery-updateFirmware'],
    async (body) => await httpClient.recovery.recoveryUpdateFirmware(body),
    {
      onError: (error) => {
        handleRestErrors(error);
      },
    },
  );
};
